import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeCollection } from '~data/selectors/collections';
import View from './view';

export default function CollectionSharingTitle({ _id, ...etc }) {
  const getCollection = useMemo(() => makeCollection(), []);
  const collection = useSelector((state) => getCollection(state, _id));

  return <View {...collection} {...etc} />;
}
